import React, { useState } from 'react';
import DaysWithDescription from '../components/DaysWithDescription';
import { orderBy } from 'lodash';
import { isDateInPast } from '../utils';

const AddButton = ({ onClick }) => (
  <div className='builder-flex builder-items-center builder-justify-center builder-border builder-border-gray-300 builder-bg-gray-50 builder-cursor-pointer hover:builder-bg-gray-100 builder-transition-all builder-p-2' onClick={onClick}>
    <i className='fal fa-plus builder-text-gray-600 builder-mr-2' />
    <span>Add new</span>
  </div>
);

const StatusBadge = ({ isExpired }) => (
  <div className={`builder-rounded-md builder-px-4 builder-py-2 ${isExpired ? 'builder-bg-yellow-50' : 'builder-bg-green-50'}`}>
    <span className={`builder-text-sm builder-font-medium ${isExpired ? 'builder-text-yellow-700' : 'builder-text-green-800'}`}>{isExpired ? 'Expired' : 'Active'}</span>
  </div>
);

const ClosingDays = ({ days, onChange, onRemove, onAdd, context }) => {
  const hasDays = days && days.length > 0;
  const [activeDay, setActiveDay] = useState(null);

  const resolveClassName = (isExpired, index) => {
    if (!isExpired) return 'builder-border-gray-100';
    if (activeDay === index) return 'builder-border-red-300';
    return 'builder-border-red-300 builder-opacity-50';
  };

  if (!hasDays) {
    return (
      <div className='builder-border builder-border-gray-100 builder-p-4 builder-space-y-4'>
        <div className='builder-flex builder-items-center'>
          <i className='fa-thin fa-empty-set builder-mr-2' />
          <div className='builder-text-[16px]'>No closing days selected.</div>
        </div>
        <AddButton onClick={onAdd} />
      </div>
    );
  }

  return (
    <div className='builder-flex builder-flex-col builder-w-full builder-flex-1'>
      <div className='builder-flex builder-justify-end builder-mb-4'>
        <AddButton onClick={onAdd} />
      </div>
      <div className='builder-grid builder-grid-cols-3 builder-gap-4'>
        {orderBy(days, ['stop'], ['desc']).map((item, i) => {
          const isExpired = isDateInPast(item.stop);
          return (
            <div key={`day-${i}`} className={`builder-border builder-p-4 builder-shadow-sm ${resolveClassName(isExpired, i)}`} onMouseEnter={() => setActiveDay(i)} onMouseLeave={() => setActiveDay(null)}>
              <DaysWithDescription item={item} onChanged={(data) => onChange({ ...data, uuid: item.uuid })} context={context} />
              <div className='builder-flex builder-justify-between builder-w-full builder-mt-4'>
                <StatusBadge isExpired={isExpired} />
                <div
                  className='builder-flex builder-justify-center builder-items-center builder-text-xs builder-text-red-500 builder-cursor-pointer hover:text-red-800 builder-p-2 builder-border builder-border-red-500 hover:builder-border-red-800'
                  style={{ width: 'fit-content' }}
                  onClick={() => onRemove(item.uuid)}
                >
                  <i className='fa-sharp fa-light fa-trash builder-mr-2' /> Remove
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClosingDays;
